import { Editor } from "@tinymce/tinymce-react";
import * as React from "react";
import { AppContext } from "../../../../setup/context";

export const TinyMCEBaseEditor = (props: {
    value: string,
    onChange?: (v: string) => void,
    onInit?: (e: any) => void;
    config: any,
    disabled?: boolean
}) => {
    const context = React.useContext(AppContext);

    return <Editor
        licenseKey={context.config.editorLicenseKey}
        onInit={(_, e) => {
            if (!!props.onInit) props.onInit(e);
        }}
        disabled={props.disabled}
        value={props.value}
        onEditorChange={e => {
            if (props.onChange) props.onChange(e);
        }}
        init={props.config}
    />;
};
